window.PK_REVIEWS = {
  "meta": {
    "total": 13,
    "avg": 5.0,
    "counts": {
      "5": 13
    },
    "generated_at": "2026-07-07",
    "summary_label": "source-labeled shared reviews across PopsyKosy",
    "display_scope": "sitewide_social_proof_only",
    "schema_scope": "product_specific_only_when_source_matches",
    "note": "First-wave Amazon source-locked customer reviews curated for high-signal display. Shared reviews keep source product and channel labels and are not emitted as product-specific schema unless the source product matches."
  },
  "reviews": [
    {
      "id": "RJOWEOYAUMENT",
      "n": "SM45375",
      "l": "the United States",
      "d": "2025-04-03",
      "s": 5,
      "t": "Great mat! Thicker is better for babies.",
      "b": "This mat is amazing! The thicker one is perfect for little ones learning to sit up. When mine was learning and he would fall over it was soft and didn’t hurt his head. It looks clean and classy as a mat. It is super easy to put together. Worth the price. I try not to walk on it with shoes on but the few times I have it holds up well.",
      "v": true,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/RJOWEOYAUMENT/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R3H19R9S8IV4T9",
      "n": "HT",
      "l": "the United States",
      "d": "2025-06-17",
      "s": 5,
      "t": "Easy to use",
      "b": "Been using this mat for some time now. We all love it as much as my baby does. It's soft, sturdy enough to walk on easily, cleans nicely and can be shortened or enlarged. And is easy to assemble and disassemble.",
      "v": true,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/R3H19R9S8IV4T9/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R2VTRCAR9XUJ0E",
      "n": "Chela Rocks",
      "l": "the United States",
      "d": "2024-08-18",
      "s": 5,
      "t": "THICK !!!",
      "b": "I have several of these play mats and they really come in handy on all floor surfaces. It really softens up a hardwood or laminate floor and it keeps a carpeted floor free from kid mess (potential spills) as well as not getting linty stuff on crawling baby hands and mouths. This one is especially nice because it is 1 inch thick... super soft and cushy. Easy to put together by just aligning the tabs and it has nice edging pieces to finish it off. Also nice because it has a cute street pattern on it in which to drive little cars on when they play pretend. Nice subtle colors. Easy to wipe up and clean. Comes in a plastic pouch thing that is not necesarily a carry about storage pouch because it has no handles, but it is nice to have to keep things together if you want to take it with you. Not as convenient in that regard as the fold up mats, but the fold up mats tend to not be as thick.",
      "v": false,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/R2VTRCAR9XUJ0E/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R1Y8WHB4Z8VJIX",
      "n": "Amazon Customer",
      "l": "the United States",
      "d": "2024-08-20",
      "s": 5,
      "t": "So thick!",
      "b": "This mat is so thick and sturdy! The pieces are easy to get locked together and fit together well. It comes in an acrylic bag that has a handle, making it easy to travel with or stow away in a closet when not using. It doesn’t slide around at all on hardwood floors (unsure about other surfaces, though) and is definitely easy to wipe clean. I love how it has the added car tracks for playtime for kids/babies, but honestly, this mat works for adult purposes as well, anywhere you might need extra cushion between you and the floor!",
      "v": false,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/R1Y8WHB4Z8VJIX/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "RE9NT3J0P8EFX",
      "n": "Ava",
      "l": "the United States",
      "d": "2024-08-27",
      "s": 5,
      "t": "Works great",
      "b": "These 1-inch thick premium quality foam play mats are fantastic! They provide excellent cushioning and durability, making them perfect for both exercise and baby play. The mats are expandable, allowing for versatile use and easy customization of your play or workout area. They’re comfortable, easy to clean, and offer great support. Highly recommend for a high-quality and versatile mat solution!",
      "v": false,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/RE9NT3J0P8EFX/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R2Z6G6KVKBS1ZL",
      "n": "Anna",
      "l": "the United States",
      "d": "2024-08-27",
      "s": 5,
      "t": "Perfect for little ones",
      "b": "We have flooring all over our living room so we really needed something to protect our little ones knees and bottom so we got this when he first started crawling and it’s been so great. He can play on this and take tumbles and Not get hurt. I also really like the look of it. It’s very aesthetically pleasing.",
      "v": false,
      "p": "Little Builders - Warm Beige",
      "h": "little-builders-warm-beige",
      "c": "Amazon.com",
      "u": "https://www.amazon.com/portal/customer-reviews/srp/-/R2Z6G6KVKBS1ZL/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R3NOL8CW7OF9W1",
      "n": "Amr Aly",
      "l": "Canada",
      "d": "2026-04-20",
      "s": 5,
      "t": "Excellent choice",
      "b": "Excellent choice … my son loved it so much, and Mommy as well 😁",
      "v": true,
      "p": "Persian Garden - Pearl Beige",
      "h": "persian-garden-pearl-beige",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R3NOL8CW7OF9W1/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R1IPU37HISKYHK",
      "n": "Vanessa Dostie-Chavez",
      "l": "Canada",
      "d": "2026-04-14",
      "s": 5,
      "t": "Love it",
      "b": "Love it. Amazing for my living room. And great for my kids to play on",
      "v": true,
      "p": "Persian Garden - Pearl Beige",
      "h": "persian-garden-pearl-beige",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R1IPU37HISKYHK/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R34G24ZYAS5HEI",
      "n": "Holly",
      "l": "Canada",
      "d": "2026-02-02",
      "s": 5,
      "t": "Love them",
      "b": "Great quality. We have been using these since oct 2025 and no issues. Love how they aren’t too bold of an pattern and it looks like a thick carpet.",
      "v": true,
      "p": "Persian Garden - Pearl Beige",
      "h": "persian-garden-pearl-beige",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R34G24ZYAS5HEI/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R3C4GMZKKS2RQS",
      "n": "Monica",
      "l": "Canada",
      "d": "2026-01-13",
      "s": 5,
      "t": "Beautiful",
      "b": "Perfect just as described",
      "v": true,
      "p": "Tranquil Flower - Baby Coral",
      "h": "baby-coral",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R3C4GMZKKS2RQS/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R2M0ULT85ZNISP",
      "n": "Annabelle",
      "l": "Canada",
      "d": "2025-09-05",
      "s": 5,
      "t": "Would recommend",
      "b": "Pretty and quite thick. Good for playing and learning to crawl.",
      "v": true,
      "p": "Tranquil Flower - Olive Green",
      "h": "olive-green",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R2M0ULT85ZNISP/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R3NPGUGN08JMR1",
      "n": "LeraLucas",
      "l": "Canada",
      "d": "2025-01-09",
      "s": 5,
      "t": "Amazing 👏",
      "b": "This foam mat is amazing! The print is so lovely and cheerful, perfect for kids. It’s super durable—even my cat couldn’t tear it up! It’s soft and safe for babies, and sturdy enough for preschoolers. Highly recommend!",
      "v": true,
      "p": "Tranquil Flower - Olive Green",
      "h": "olive-green",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R3NPGUGN08JMR1/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    },
    {
      "id": "R11B99CH8KB9DY",
      "n": "Jodie",
      "l": "Canada",
      "d": "2025-01-15",
      "s": 5,
      "t": "Working well in our playroom",
      "b": "I purchased 4 of these mats to cover the playroom floor. The pieces fit well together and are easy to assemble. The outer edge did need a small cut where I joined one section to another section. I was a little frustrated that the pattern did not join up when two mats were joined together however this seems to go unnoticed given the number of mats I have. The mats are comfortable to walk on and certainly help when the baby falls and knocks his head. The mats seem to be holding up under dog and cat nails and they are easy to wipe down if something spills. Overall, I’m happy with the purchase.",
      "v": true,
      "p": "Tranquil Flower - Gray",
      "h": "tranquil-flower-gray",
      "c": "Amazon.ca",
      "u": "https://www.amazon.ca/portal/customer-reviews/srp/-/R11B99CH8KB9DY/ref=cm_cr_arp_d_rvw_ttl?ie=UTF8"
    }
  ]
};
window.dispatchEvent(new Event("pk-reviews-ready"));
